// TODO - we should collaborate with AI team to figure out a
// better system for these bucket/label mappings
// Note: order of these keys matters for chart display
export const sizeBucketLabelMap: Record<string, string> = {
  very_small: '4-7mm',
  small: '7-12mm',
  large: '12-17mm',
  very_large: '17-22mm',
  extra_large: '22-29mm',
  ultra_large: '29-35mm',
  unknown: 'Unmeasurable',
};

export type SizeBucket = keyof typeof sizeBucketLabelMap;
